export const WEBBRG_REQUEST = 'webbrg/REQUEST'
export const WEBBRG_REQUEST_SUCCESS = 'webbrg/REQUEST_SUCCESS'
export const WEBBRG_REQUEST_ERROR = 'webbrg/REQUEST_ERROR'

export function requestNews() {
    return async (dispatch, getState) => {
        dispatch({ type: WEBBRG_REQUEST })
        const { settings } = getState()
        const url = `${settings.gatewayHost}/webbrg/clannews/api/list/`

        try {
            const response = await fetch(url).then(response => {
                if (!response.ok) throw response.statusText
                return response.json()
            })

            dispatch({
                type: WEBBRG_REQUEST_SUCCESS,
                payload: response,
            })
        } catch (e) {
            dispatch({
                type: WEBBRG_REQUEST_ERROR,
            })
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/webbrg.js